import { ContentRepository } from './getContentVersionId';

// This map to the backend property externalUniqueId which is the real identifier of the content
export const getContentVersionIdByManifest = (manifest) => {
    switch (manifest?.Content?.Repository?.toString().toLowerCase()) {
    case ContentRepository.DOCCENTER:
        return manifest?.Content?.LibraryContent?.VersionId;
    case ContentRepository.LIBRARY:
    case ContentRepository.WORKSPACE:
        return manifest?.Content?.VersionId;
    case ContentRepository.LIVEDOC:
        return manifest?.Content?.Id;
    case ContentRepository.CMS:
        return manifest?.Content?.NodeId;
    default:
        return manifest?.Content?.VersionId || '';
    }
};
